import React from "react";
import { QueryRenderer, ReadyState } from "react-relay";

import { IOrg } from "@schema";

import { adminPanelOverviewQuery } from "./AdminPanelOverview.gql";

import { Loader } from "@clockwise/web-commons/src/components/loader";
import { Overview } from "@clockwise/web-commons/src/ui/admin-panel/overview";

import { handleReadyStateError } from "@util/relay.util";
import { getCurrentEnvironment } from "@src/state/relay-environment";
import { getOrgOverview } from "@components/admin-panel/AdminPanel.util";
import { remapOrgOverviewLabels } from "./AdminPanelOverview.util";

export interface IAdminPanelOverviewContainerProps {
  orgRelayId: string;
}

export const AdminPanelOverviewContainer = ({ orgRelayId }: IAdminPanelOverviewContainerProps) => {
  let cachedOrg: IOrg;
  const environment = getCurrentEnvironment();

  return (
    <QueryRenderer
      environment={environment}
      query={adminPanelOverviewQuery}
      variables={{ orgRelayId }}
      render={(readyState: ReadyState) => {
        const { error, props } = readyState;
        if (error) {
          handleReadyStateError(error, "AdminPanelOverview");
          return null;
        }

        const org = (props && props.org) || null;

        if (org) {
          cachedOrg = org;
        }

        if (!cachedOrg) {
          return <Loader />;
        }

        const orgOverview = getOrgOverview(cachedOrg);
        return <Overview orgOverview={orgOverview && remapOrgOverviewLabels(orgOverview)} />;
      }}
    />
  );
};
